import React from 'react';
import { ConfigProvider, Menu as AntMenu, Dropdown as AntDropdown, DropDownProps } from 'antd';
import { MenuProps, MenuItemProps, MenuDividerProps } from 'antd/lib/menu';
import styled from 'styled-components';
import { DropdownButtonProps } from 'antd/lib/dropdown';

import { nextMenuTheme } from '../next/tokens';

export type { MenuProps } from 'antd/lib/menu';
export type { MenuItemProps } from 'antd/lib/menu';
export type { DropDownProps } from 'antd/lib/dropdown';

export const Dropdown: React.FC<DropDownProps> = (props) => <AntDropdown {...props} />;

type MenuVariant = 'next';

interface MenuWithVariantProps extends MenuProps {
  variant?: MenuVariant;
}

/**
 * Minimal CSS for Menu next variant — only for things ConfigProvider tokens can't express.
 */
const NextMenu = styled(AntMenu)`
  &.ant-menu {
    border: none !important;

    .ant-menu-item {
      padding-inline-start: 4px;
      padding-inline-end: 6px;
      margin-inline: 0;
      width: 100%;
      color: ${({ theme }) => theme.token.next.palette.grey700};
    }

    .ant-menu-item-divider {
      border-color: ${({ theme }) => theme.token.next.palette.grey75};
    }
  }
` as typeof AntMenu;

export const Menu: React.FC<MenuWithVariantProps> = ({ variant, ...rest }) => {
  if (variant === 'next') {
    return (
      <ConfigProvider theme={nextMenuTheme}>
        <NextMenu {...rest} />
      </ConfigProvider>
    );
  }
  return <AntMenu {...rest} />;
};

export const MenuItem: React.FC<MenuItemProps> = (props) => <AntMenu.Item {...props} />;

export const DropdownButton: React.FC<Omit<DropdownButtonProps, 'arrow'>> = ({
  size = 'large',
  ...rest
}) => <AntDropdown.Button size={size} {...rest} />;

export const MenuDivider: React.FC<MenuDividerProps> = (props) => <AntMenu.Divider {...props} />;
